// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-sidebar {
  width: 350px;
  height: 100vh;
  position: sticky;
  top: 0;
  border-left: 1px solid var(--border-color);
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.sidebar-header {
  display: none;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border-color);
  justify-content: flex-end;
}

.sidebar-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 44px;
  transition: background-color 0.2s;
}

.sidebar-close-btn:hover {
  background: var(--hover-bg);
}

.sidebar-close-btn svg {
  width: 24px;
  height: 24px;
}

/* Expand/collapse toggle — only visible at 769px–1024px via media query */
.right-sidebar .sidebar-toggle-btn {
  display: none;
  align-items: center;
  justify-content: flex-end;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-primary);
  width: 100%;
  height: 44px;
  border-radius: unset;
  transition: background-color 0.2s;
  flex-shrink: 0;
  position: relative;
}

.sidebar-toggle-count {
  position: absolute;
  top: 6px;
  right: 12px;
  min-width: 18px;
  height: 18px;
  border-radius: 999px;
  background: var(--accent-primary);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  padding: 0 5px;
}

.right-sidebar.expanded .sidebar-toggle-btn {
  justify-content: flex-end;
  padding-right: 24px;
}

.right-sidebar .sidebar-toggle-btn:hover {
  background: var(--hover-bg);
}

/* Backdrop for expanded overlay */
.right-sidebar ~ .sidebar-expanded-backdrop {
  display: none;
}

.right-sidebar-content {
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Notiflexion Link */
.notiflexion-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 16px;
  text-decoration: none;
  transition: background-color 0.2s;
}

.notiflexion-link:hover {
  background: var(--hover-bg);
}

.notiflexion-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.notiflexion-icon {
  width: 24px;
  height: 24px;
  color: var(--text-primary);
}

.notiflexion-header span {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
}

.notiflexion-count {
  background: var(--primary-color);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  min-width: 24px;
  text-align: center;
}

/* Auth Section */
.sidebar-auth {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  transition: border 0.2s;
  border: solid 1px transparent;
}

.sidebar-auth:hover {
  border: 1px solid var(--accent-hover);
}

.auth-user-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color);
  cursor: pointer;
}

.auth-user-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.auth-user-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.auth-avatar-container {
  position: relative;
  display: flex;
}

.profile-menu-chevron {
  display: none;
  position: absolute;
  bottom: -4px;
  right: -4px;
  width: 18px;
  height: 18px;
  min-width: 18px;
  flex-shrink: 0;
  background: var(--bg-primary, #fff);
  border-radius: 50%;
  color: var(--text-secondary, #888);
  transition: transform 0.2s ease;
  box-shadow: 0 0 2px rgba(0,0,0,0.2);
}

.profile-menu-chevron.open {
  transform: rotate(180deg);
}

.auth-user-mana-container {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.auth-user-mana-bars {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1 120px;
  padding: 0 4px;
  cursor: pointer;
}

.mana-refresh-btn {
  background: none;
  border: none;
  color: var(--text-secondary, #888);
  cursor: pointer;
  padding: 2px 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  border-radius: 4px;
}

.mana-refresh-btn:hover {
  color: var(--primary-color);
  background: var(--hover-bg);
}

.mana-refresh-btn svg {
  width: 14px;
  height: 14px;
}

.mana-refresh-btn.refreshing svg {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.mana-progress-wrapper {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mana-value-text {
  font-size: 10px;
  color: var(--text-secondary, #888);
  line-height: 1;
}

.mana-progress {
  width: 100%;
  background-color: var(--hover-bg, #333);
  border-radius: 4px;
  overflow: hidden;
}

.mana-micro {
  height: 4px;
}

.mana-progress-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}

.bg-primary {
  background-color: var(--primary-color);
}

.bg-rc {
  background-color: #17a2b8;
}

.auth-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.auth-user-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.auth-username {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  text-decoration: none;
  transition: color 0.2s;
}

.auth-username:hover {
  color: var(--primary-color);
}

.auth-settings-link {
  font-size: 12px;
  color: var(--primary-color);
  text-decoration: none;
}

.auth-settings-link:hover {
  text-decoration: underline;
}

/* Profile Menu - visible only between 768px-1024px on click */
.profile-menu {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 12px;
  padding: 8px 0;
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
  align-items: center;
}

.profile-menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
}

.profile-menu-item:hover {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--text-primary);
  transform: translateY(-2px);
}

.profile-menu-item svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
}

.profile-menu-item.logout-btn:hover {
  background: var(--error-color, #dc2626);
  border-color: var(--error-color, #dc2626);
}

.logout-btn svg {
  stroke: var(--error-color);
}

svg.add-account-icon {
  stroke: var(--primary-color);
}

svg.setting-svg {
  stroke: var(--text-primary);
}

.auth-accounts {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.auth-accounts-header {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.auth-account-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 13px;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.auth-account-item:hover {
  background: var(--hover-bg);
  transform: translateX(4px);
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.auth-account-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.auth-add-account {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
}

.add-account-icon {
  width: 16px;
  height: 16px;
  stroke: currentColor;
}

.auth-add-account:hover {
  background: var(--hover-bg);
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.auth-logout {
  width: 100%;
  padding: 10px 16px;
  background: transparent;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--error-color, #dc2626);
  cursor: pointer;
  transition: all 0.2s;
}

.auth-logout:hover {
  background: var(--error-color, #dc2626);
  color: var(--text-primary);
  border-color: var(--error-color, #dc2626);
}

/* Login Button */
.right-sidebar .login-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 24px;
  background: var(--primary-color);
  color: var(--text-primary);
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s;
}

.right-sidebar .sidebar-login-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 14px 24px;
  background: var(--primary-color);
  color: var(--text-primary);
  border: none;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.right-sidebar .sidebar-login-btn:hover {
    background: var(--primary-hover);
}

.right-sidebar .login-btn:hover {
  background: var(--primary-hover);
}

.btn-icon {
  width: 20px;
  height: 20px;
}

/* PIN Modal */
.pin-modal {
  background: var(--card-bg);
  border-radius: 16px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  color: var(--text-primary);
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.close-btn:hover {
  background: var(--hover-bg);
}

.form-group {
  margin-bottom: 20px;
}

.pin-input {
  width: 100%;
  padding: 12px 16px;
  font-size: 24px;
  letter-spacing: 8px;
  text-align: center;
  border: 2px solid var(--border-color);
  border-radius: 8px;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: monospace;
}

.pin-input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.error-message {
  padding: 12px;
  margin-bottom: 16px;
  background: var(--error-bg, #fee);
  border: 1px solid var(--error-border, #fcc);
  border-radius: 8px;
  color: var(--error-color, #c33);
  font-size: 14px;
}

.right-sidebar .login-btn {
  width: 100%;
  padding: 12px;
  background: var(--primary-color);
  color: var(--text-primary);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.right-sidebar .login-btn:hover:not(:disabled) {
  background: var(--primary-hover);
}

.right-sidebar .login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 1299.9px) {
  .right-sidebar {
    width: 280px;
  }
}
@media (max-width: 1159.9px) {
  .right-sidebar {
    width:unset;
  }
}
@media (max-width: 1024px) {
  .right-sidebar {
    width: 88px;
  }

  .right-sidebar-content {
    padding: 20px 8px;
  }

  .notiflexion-link {
    justify-content: center;
    padding: 12px;
  }

  .notiflexion-count {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .sidebar-auth {
    padding: 12px;
    justify-content: center;
  }

  .auth-user-info {
    padding: 0;
    border: none;
    justify-content: center;
  }

  .right-sidebar .login-btn,
  .right-sidebar .sidebar-login-btn {
    padding: 12px;
    font-size: 14px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .mana-refresh-btn {
    width:100%;
  }
  
  /* Show header bar with toggle button */
  .right-sidebar .sidebar-header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
  }

  /* Hide the mobile-only close button in this range */
  .right-sidebar .sidebar-close-btn {
    display: none;
  }

  .right-sidebar .sidebar-toggle-btn {
    display: flex;
    justify-content: center;
  }

  /* Condensed-only styles (not applied when expanded) */
  .right-sidebar:not(.expanded) .sidebar-login-btn span {
    display: none;
  }

  .right-sidebar:not(.expanded) .notiflexion-header span,
  .right-sidebar:not(.expanded) .auth-user-details,
  .right-sidebar:not(.expanded) .auth-accounts-header,
  .right-sidebar:not(.expanded) .auth-accounts,
  .right-sidebar:not(.expanded) .sidebar-auth > button:not(.profile-menu-item),
  .right-sidebar:not(.expanded) .sidebar-auth > div:not(.auth-user-info):not(.profile-menu),
  .right-sidebar:not(.expanded) .sidebar-auth .auth-user-details,
  .right-sidebar:not(.expanded) .sidebar-auth .auth-accounts {
    display: none;
  }

  .right-sidebar:not(.expanded) .auth-user-info {
    cursor: pointer;
  }

  .right-sidebar:not(.expanded) .profile-menu {
    display: flex;
  }

  .right-sidebar:not(.expanded) .profile-menu-chevron {
    display: block;
  }

  /* ── Expanded overlay state ── */
  /* Base sidebar-inner: fill the 88px shell normally */
  .sidebar-inner {
    display: flex;
    flex-direction: column;
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
  }

  /* Shell stays 88px in flex flow; z-index creates the stacking context anchor */
  .right-sidebar.expanded {
    overflow: visible;
    z-index: 2000;
  }

  /* Inner panel: absolutely positioned inside the aside's stacking context */
  .right-sidebar.expanded .sidebar-inner {
    position: absolute;
    top: 0;
    right: 0;
    width: 350px;
    height: 100vh;
    background: var(--bg-primary);
    border-left: 1px solid var(--border-color);
    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  .right-sidebar.expanded .sidebar-header {
    justify-content: flex-start;
    padding: 8px 12px;
  }

  .right-sidebar.expanded .right-sidebar-content {
    padding: 20px 16px;
  }

  .right-sidebar.expanded .notiflexion-link {
    justify-content: space-between;
    padding: 16px;
  }

  .right-sidebar.expanded .notiflexion-header span {
    display: block;
  }

  .right-sidebar.expanded .notiflexion-count {
    position: static;
  }

  .right-sidebar.expanded .sidebar-auth {
    padding: 16px;
    justify-content: initial;
  }

  .right-sidebar.expanded .auth-user-info {
    padding-bottom: 12px;
    border-bottom: 1px solid var(--border-color);
    justify-content: initial;
    cursor: initial;
  }

  .right-sidebar.expanded .auth-user-details,
  .right-sidebar.expanded .auth-accounts-header,
  .right-sidebar.expanded .auth-accounts,
  .right-sidebar.expanded .sidebar-auth > button:not(.profile-menu-item),
  .right-sidebar.expanded .sidebar-auth > div:not(.auth-user-info):not(.profile-menu),
  .right-sidebar.expanded .sidebar-login-btn span {
    display: flex;
  }

  .right-sidebar.expanded .auth-accounts-header {
    display: block;
  }

  .right-sidebar.expanded .profile-menu {
    display: none;
  }

  .right-sidebar.expanded .right-sidebar .login-btn,
  .right-sidebar.expanded .right-sidebar .sidebar-login-btn {
    padding: 14px 24px;
    font-size: 16px;
  }

  /* Backdrop */
  .sidebar-expanded-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.25);
    z-index: 1999;
  }
}

@media (max-width: 768px) {
  .right-sidebar {
    display: flex;
    width: 350px;
    max-width:100%;
    background: var(--bg-primary);
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  }

  .right-sidebar-content {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px 16px;
  }

  .sidebar-header {
    display: flex;
  }

  .notiflexion-header span {
    display: block;
  }

  .auth-accounts-header {
    display: block;
  }

  .auth-accounts {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .notiflexion-link {
    justify-content: space-between;
    padding: 16px;
  }

  .notiflexion-count {
    position: static;
  }

  .sidebar-auth {
    padding: 16px;
    justify-content: initial;
  }

  .auth-avatar {
    width: 48px;
    height: 48px;
  }

  .auth-user-info {
    justify-content: initial;
    padding-bottom: 12px;
    border-bottom: 1px solid var(--border-color);
    cursor: initial;
  }

  .auth-user-details {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .profile-menu {
    display: none !important;
  }

  .right-sidebar .login-btn,
  .right-sidebar .sidebar-login-btn {
    padding: 14px 24px;
    font-size: 16px;
  }
}
.mana-progress.loading, .profile-mana-track.loading {
  animation: manaPulse 1.5s infinite ease-in-out;
  background-color: var(--border-color);
}
@keyframes manaPulse {
  0% { opacity: 0.6; }
  50% { opacity: 0.3; }
  100% { opacity: 0.6; }
}
`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/RightSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,MAAM;EACN,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gCAAgC;EAChC,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA,uCAAuC;EACvC;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA,oDAAoD;EACpD;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA,sDAAsD;EACtD;IACE,aAAa;EACf;;EAEA;;;;;;;;IAQE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA,iCAAiC;EACjC,qDAAqD;EACrD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,aAAa;IACb,gBAAgB;EAClB;;EAEA,+EAA+E;EAC/E;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA,2EAA2E;EAC3E;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,6BAA6B;IAC7B,0CAA0C;IAC1C,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;IACpB,4CAA4C;IAC5C,wBAAwB;IACxB,eAAe;EACjB;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,aAAa;EACb;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,6BAA6B;IAC7B,yCAAyC;EAC3C;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,4CAA4C;IAC5C,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;AACA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,YAAY,EAAE;EACpB,OAAO,YAAY,EAAE;AACvB","sourcesContent":[".right-sidebar {\r\n  width: 350px;\r\n  height: 100vh;\r\n  position: sticky;\r\n  top: 0;\r\n  border-left: 1px solid var(--border-color);\r\n  overflow-y: auto;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.sidebar-header {\r\n  display: none;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  justify-content: flex-end;\r\n}\r\n\r\n.sidebar-close-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  height: 44px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.sidebar-close-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.sidebar-close-btn svg {\r\n  width: 24px;\r\n  height: 24px;\r\n}\r\n\r\n/* Expand/collapse toggle — only visible at 769px–1024px via media query */\r\n.right-sidebar .sidebar-toggle-btn {\r\n  display: none;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: var(--text-primary);\r\n  width: 100%;\r\n  height: 44px;\r\n  border-radius: unset;\r\n  transition: background-color 0.2s;\r\n  flex-shrink: 0;\r\n  position: relative;\r\n}\r\n\r\n.sidebar-toggle-count {\r\n  position: absolute;\r\n  top: 6px;\r\n  right: 12px;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  border-radius: 999px;\r\n  background: var(--accent-primary);\r\n  color: #fff;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 18px;\r\n  text-align: center;\r\n  padding: 0 5px;\r\n}\r\n\r\n.right-sidebar.expanded .sidebar-toggle-btn {\r\n  justify-content: flex-end;\r\n  padding-right: 24px;\r\n}\r\n\r\n.right-sidebar .sidebar-toggle-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n/* Backdrop for expanded overlay */\r\n.right-sidebar ~ .sidebar-expanded-backdrop {\r\n  display: none;\r\n}\r\n\r\n.right-sidebar-content {\r\n  padding: 20px 16px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* Notiflexion Link */\r\n.notiflexion-link {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 16px;\r\n  border-radius: 16px;\r\n  text-decoration: none;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.notiflexion-link:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.notiflexion-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.notiflexion-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.notiflexion-header span {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.notiflexion-count {\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  min-width: 24px;\r\n  text-align: center;\r\n}\r\n\r\n/* Auth Section */\r\n.sidebar-auth {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 16px;\r\n  border-radius: 16px;\r\n  transition: border 0.2s;\r\n  border: solid 1px transparent;\r\n}\r\n\r\n.sidebar-auth:hover {\r\n  border: 1px solid var(--accent-hover);\r\n}\r\n\r\n.auth-user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--border-color);\r\n  cursor: pointer;\r\n}\r\n\r\n.auth-user-header-content {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n}\r\n\r\n.auth-user-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.auth-avatar-container {\r\n  position: relative;\r\n  display: flex;\r\n}\r\n\r\n.profile-menu-chevron {\r\n  display: none;\r\n  position: absolute;\r\n  bottom: -4px;\r\n  right: -4px;\r\n  width: 18px;\r\n  height: 18px;\r\n  min-width: 18px;\r\n  flex-shrink: 0;\r\n  background: var(--bg-primary, #fff);\r\n  border-radius: 50%;\r\n  color: var(--text-secondary, #888);\r\n  transition: transform 0.2s ease;\r\n  box-shadow: 0 0 2px rgba(0,0,0,0.2);\r\n}\r\n\r\n.profile-menu-chevron.open {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.auth-user-mana-container {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  width: 100%;\r\n}\r\n\r\n.auth-user-mana-bars {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1 1 120px;\r\n  padding: 0 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.mana-refresh-btn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--text-secondary, #888);\r\n  cursor: pointer;\r\n  padding: 2px 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: color 0.2s;\r\n  border-radius: 4px;\r\n}\r\n\r\n.mana-refresh-btn:hover {\r\n  color: var(--primary-color);\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.mana-refresh-btn svg {\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n.mana-refresh-btn.refreshing svg {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.mana-progress-wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n}\r\n\r\n.mana-value-text {\r\n  font-size: 10px;\r\n  color: var(--text-secondary, #888);\r\n  line-height: 1;\r\n}\r\n\r\n.mana-progress {\r\n  width: 100%;\r\n  background-color: var(--hover-bg, #333);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n}\r\n\r\n.mana-micro {\r\n  height: 4px;\r\n}\r\n\r\n.mana-progress-bar {\r\n  height: 100%;\r\n  border-radius: 4px;\r\n  transition: width 0.3s ease;\r\n}\r\n\r\n.bg-primary {\r\n  background-color: var(--primary-color);\r\n}\r\n\r\n.bg-rc {\r\n  background-color: #17a2b8;\r\n}\r\n\r\n.auth-avatar {\r\n  width: 48px;\r\n  height: 48px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.auth-user-details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.auth-username {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.auth-username:hover {\r\n  color: var(--primary-color);\r\n}\r\n\r\n.auth-settings-link {\r\n  font-size: 12px;\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.auth-settings-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Profile Menu - visible only between 768px-1024px on click */\r\n.profile-menu {\r\n  display: none;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 8px 0;\r\n  border-top: 1px solid var(--border-color);\r\n  margin-top: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.profile-menu-item {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  padding: 0;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n  text-decoration: none;\r\n}\r\n\r\n.profile-menu-item:hover {\r\n  background: var(--primary-color);\r\n  border-color: var(--primary-color);\r\n  color: var(--text-primary);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n.profile-menu-item svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke: currentColor;\r\n}\r\n\r\n.profile-menu-item.logout-btn:hover {\r\n  background: var(--error-color, #dc2626);\r\n  border-color: var(--error-color, #dc2626);\r\n}\r\n\r\n.logout-btn svg {\r\n  stroke: var(--error-color);\r\n}\r\n\r\nsvg.add-account-icon {\r\n  stroke: var(--primary-color);\r\n}\r\n\r\nsvg.setting-svg {\r\n  stroke: var(--text-primary);\r\n}\r\n\r\n.auth-accounts {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.auth-accounts-header {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--text-secondary);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.auth-account-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.auth-account-item:hover {\r\n  background: var(--hover-bg);\r\n  transform: translateX(4px);\r\n  border-color: var(--primary-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.auth-account-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.auth-add-account {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  background: var(--card-bg);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.add-account-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  stroke: currentColor;\r\n}\r\n\r\n.auth-add-account:hover {\r\n  background: var(--hover-bg);\r\n  border-color: var(--primary-color);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.auth-logout {\r\n  width: 100%;\r\n  padding: 10px 16px;\r\n  background: transparent;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--error-color, #dc2626);\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.auth-logout:hover {\r\n  background: var(--error-color, #dc2626);\r\n  color: var(--text-primary);\r\n  border-color: var(--error-color, #dc2626);\r\n}\r\n\r\n/* Login Button */\r\n.right-sidebar .login-btn {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 14px 24px;\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 24px;\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.right-sidebar .sidebar-login-btn {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 14px 24px;\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 24px;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.right-sidebar .sidebar-login-btn:hover {\r\n    background: var(--primary-hover);\r\n}\r\n\r\n.right-sidebar .login-btn:hover {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.btn-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n/* PIN Modal */\r\n.pin-modal {\r\n  background: var(--card-bg);\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  max-width: 400px;\r\n  width: 90%;\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 28px;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 32px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: var(--hover-bg);\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.pin-input {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  font-size: 24px;\r\n  letter-spacing: 8px;\r\n  text-align: center;\r\n  border: 2px solid var(--border-color);\r\n  border-radius: 8px;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  font-family: monospace;\r\n}\r\n\r\n.pin-input:focus {\r\n  outline: none;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.error-message {\r\n  padding: 12px;\r\n  margin-bottom: 16px;\r\n  background: var(--error-bg, #fee);\r\n  border: 1px solid var(--error-border, #fcc);\r\n  border-radius: 8px;\r\n  color: var(--error-color, #c33);\r\n  font-size: 14px;\r\n}\r\n\r\n.right-sidebar .login-btn {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background: var(--primary-color);\r\n  color: var(--text-primary);\r\n  border: none;\r\n  border-radius: 8px;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.right-sidebar .login-btn:hover:not(:disabled) {\r\n  background: var(--primary-hover);\r\n}\r\n\r\n.right-sidebar .login-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 1299.9px) {\r\n  .right-sidebar {\r\n    width: 280px;\r\n  }\r\n}\r\n@media (max-width: 1159.9px) {\r\n  .right-sidebar {\r\n    width:unset;\r\n  }\r\n}\r\n@media (max-width: 1024px) {\r\n  .right-sidebar {\r\n    width: 88px;\r\n  }\r\n\r\n  .right-sidebar-content {\r\n    padding: 20px 8px;\r\n  }\r\n\r\n  .notiflexion-link {\r\n    justify-content: center;\r\n    padding: 12px;\r\n  }\r\n\r\n  .notiflexion-count {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 8px;\r\n  }\r\n\r\n  .sidebar-auth {\r\n    padding: 12px;\r\n    justify-content: center;\r\n  }\r\n\r\n  .auth-user-info {\r\n    padding: 0;\r\n    border: none;\r\n    justify-content: center;\r\n  }\r\n\r\n  .right-sidebar .login-btn,\r\n  .right-sidebar .sidebar-login-btn {\r\n    padding: 12px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (min-width: 769px) and (max-width: 1024px) {\r\n  .mana-refresh-btn {\r\n    width:100%;\r\n  }\r\n  \r\n  /* Show header bar with toggle button */\r\n  .right-sidebar .sidebar-header {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px;\r\n  }\r\n\r\n  /* Hide the mobile-only close button in this range */\r\n  .right-sidebar .sidebar-close-btn {\r\n    display: none;\r\n  }\r\n\r\n  .right-sidebar .sidebar-toggle-btn {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n\r\n  /* Condensed-only styles (not applied when expanded) */\r\n  .right-sidebar:not(.expanded) .sidebar-login-btn span {\r\n    display: none;\r\n  }\r\n\r\n  .right-sidebar:not(.expanded) .notiflexion-header span,\r\n  .right-sidebar:not(.expanded) .auth-user-details,\r\n  .right-sidebar:not(.expanded) .auth-accounts-header,\r\n  .right-sidebar:not(.expanded) .auth-accounts,\r\n  .right-sidebar:not(.expanded) .sidebar-auth > button:not(.profile-menu-item),\r\n  .right-sidebar:not(.expanded) .sidebar-auth > div:not(.auth-user-info):not(.profile-menu),\r\n  .right-sidebar:not(.expanded) .sidebar-auth .auth-user-details,\r\n  .right-sidebar:not(.expanded) .sidebar-auth .auth-accounts {\r\n    display: none;\r\n  }\r\n\r\n  .right-sidebar:not(.expanded) .auth-user-info {\r\n    cursor: pointer;\r\n  }\r\n\r\n  .right-sidebar:not(.expanded) .profile-menu {\r\n    display: flex;\r\n  }\r\n\r\n  .right-sidebar:not(.expanded) .profile-menu-chevron {\r\n    display: block;\r\n  }\r\n\r\n  /* ── Expanded overlay state ── */\r\n  /* Base sidebar-inner: fill the 88px shell normally */\r\n  .sidebar-inner {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    min-height: 0;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  /* Shell stays 88px in flex flow; z-index creates the stacking context anchor */\r\n  .right-sidebar.expanded {\r\n    overflow: visible;\r\n    z-index: 2000;\r\n  }\r\n\r\n  /* Inner panel: absolutely positioned inside the aside's stacking context */\r\n  .right-sidebar.expanded .sidebar-inner {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    width: 350px;\r\n    height: 100vh;\r\n    background: var(--bg-primary);\r\n    border-left: 1px solid var(--border-color);\r\n    box-shadow: -4px 0 16px rgba(0, 0, 0, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .right-sidebar.expanded .sidebar-header {\r\n    justify-content: flex-start;\r\n    padding: 8px 12px;\r\n  }\r\n\r\n  .right-sidebar.expanded .right-sidebar-content {\r\n    padding: 20px 16px;\r\n  }\r\n\r\n  .right-sidebar.expanded .notiflexion-link {\r\n    justify-content: space-between;\r\n    padding: 16px;\r\n  }\r\n\r\n  .right-sidebar.expanded .notiflexion-header span {\r\n    display: block;\r\n  }\r\n\r\n  .right-sidebar.expanded .notiflexion-count {\r\n    position: static;\r\n  }\r\n\r\n  .right-sidebar.expanded .sidebar-auth {\r\n    padding: 16px;\r\n    justify-content: initial;\r\n  }\r\n\r\n  .right-sidebar.expanded .auth-user-info {\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--border-color);\r\n    justify-content: initial;\r\n    cursor: initial;\r\n  }\r\n\r\n  .right-sidebar.expanded .auth-user-details,\r\n  .right-sidebar.expanded .auth-accounts-header,\r\n  .right-sidebar.expanded .auth-accounts,\r\n  .right-sidebar.expanded .sidebar-auth > button:not(.profile-menu-item),\r\n  .right-sidebar.expanded .sidebar-auth > div:not(.auth-user-info):not(.profile-menu),\r\n  .right-sidebar.expanded .sidebar-login-btn span {\r\n    display: flex;\r\n  }\r\n\r\n  .right-sidebar.expanded .auth-accounts-header {\r\n    display: block;\r\n  }\r\n\r\n  .right-sidebar.expanded .profile-menu {\r\n    display: none;\r\n  }\r\n\r\n  .right-sidebar.expanded .right-sidebar .login-btn,\r\n  .right-sidebar.expanded .right-sidebar .sidebar-login-btn {\r\n    padding: 14px 24px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  /* Backdrop */\r\n  .sidebar-expanded-backdrop {\r\n    display: block;\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0, 0, 0, 0.25);\r\n    z-index: 1999;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .right-sidebar {\r\n    display: flex;\r\n    width: 350px;\r\n    max-width:100%;\r\n    background: var(--bg-primary);\r\n    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n\r\n  .right-sidebar-content {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    padding: 20px 16px;\r\n  }\r\n\r\n  .sidebar-header {\r\n    display: flex;\r\n  }\r\n\r\n  .notiflexion-header span {\r\n    display: block;\r\n  }\r\n\r\n  .auth-accounts-header {\r\n    display: block;\r\n  }\r\n\r\n  .auth-accounts {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n  }\r\n\r\n  .notiflexion-link {\r\n    justify-content: space-between;\r\n    padding: 16px;\r\n  }\r\n\r\n  .notiflexion-count {\r\n    position: static;\r\n  }\r\n\r\n  .sidebar-auth {\r\n    padding: 16px;\r\n    justify-content: initial;\r\n  }\r\n\r\n  .auth-avatar {\r\n    width: 48px;\r\n    height: 48px;\r\n  }\r\n\r\n  .auth-user-info {\r\n    justify-content: initial;\r\n    padding-bottom: 12px;\r\n    border-bottom: 1px solid var(--border-color);\r\n    cursor: initial;\r\n  }\r\n\r\n  .auth-user-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n\r\n  .profile-menu {\r\n    display: none !important;\r\n  }\r\n\r\n  .right-sidebar .login-btn,\r\n  .right-sidebar .sidebar-login-btn {\r\n    padding: 14px 24px;\r\n    font-size: 16px;\r\n  }\r\n}\r\n.mana-progress.loading, .profile-mana-track.loading {\n  animation: manaPulse 1.5s infinite ease-in-out;\n  background-color: var(--border-color);\n}\n@keyframes manaPulse {\n  0% { opacity: 0.6; }\n  50% { opacity: 0.3; }\n  100% { opacity: 0.6; }\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
